(function() {

  var phoneNumberInput = document.getElementsByName("customer[phone]");


  function validatePhoneNumber(node) {
    const phoneInput = node

    //Block addining value to input by pasting
    phoneInput.addEventListener("paste", function(e) {
      e.preventDefault();
    });

    phoneInput.addEventListener('keydown', function(e) {
      if (e.key === ' ') {
        e.preventDefault();
      }
      // Only ASCII character in that range allowed
      let ASCIICode = e.keyCode;
      if (!(  ASCIICode >= 48 && ASCIICode <= 57  ||
              ASCIICode >= 96 && ASCIICode <= 105 ||
              ASCIICode == 8) || 
              !isNumeric(e.key)) {
          e.preventDefault();
      } 

    });

  }

  function isNumeric(value) {
    if(value === 'Backspace') {
      return true;
    }
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  function init() {
    //Call function for phone number validation
    phoneNumberInput.forEach((number)=> {
      validatePhoneNumber(number);
    });
    
    
  }

  // Initiate functions
  document.addEventListener("DOMContentLoaded", function() {
    init();    
  });

}());